import { useState } from "react";
import "./styles.sass";
import { useHandler } from "./handler";
import assets from "../../assets";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminLiveQuizRoom } from "../admin-live-room";
import { AdminLeaderboard } from "../admin-leader-board";
import { AdminQuizHistory } from "../admin-quiz-history";
import { ROUTE_TEST_MANAGEMENT, ROUTE_CLASSROOM_QUIZ_SUMMARY } from "../../route/teacherRoute";
import { AddStudentsModal } from "../test-management";

export const AdminAsyncQuizRoom = ({ roomCode, setShowLeaderboard }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLeaderboard, setShowLeaderboardNew] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const roomCodeNew = location.state?.roomCode || roomCode;
  const mode = location.state?.mode || "async";
  const testName = location.state?.testName || location.state?.test_name;
  console.log(location, roomCodeNew, mode, testName, "romasyncadmin");

  const {
    quizResult,
    search,
    getQuizResult,
    closeRoom,
    setSearch,
    showAddStudentsModal,
    setShowAddStudentsModal,
    studentMailDetails,
    getStudentMailsList,
    selectedStudents,
    setSelectedStudents,
    searchQuery,
    setSearchQuery,
    isLoading,
    addStudentsToRoom,
  } = useHandler({
    roomCode: roomCodeNew,
    mode,
    testName,
    setShowLeaderboard: setShowLeaderboardNew,
  });
  
   const resetQuizFlow = () => {
     setShowLeaderboardNew(false);
       navigate(ROUTE_TEST_MANAGEMENT);
    
  };
  
  console.log(quizResult,"qwuizresultcloseroom")

  const submittedStudents =
    quizResult?.submitted?.map((item) => ({
      name: item.nickname,

      status: "Submitted",

      score: item.score,

      maxScore: item.max_score,

      attempts: `${item.attempts_used}/${quizResult?.max_attempts}`,

      time: new Date(item.submitted_at).toLocaleTimeString(),
    })) || [];

  const pendingStudents =
    quizResult?.not_started?.map((item) => ({
      name: item.nickname,

      status: "Not Submitted",

      score: 0,

      maxScore: 1000,

      attempts: "-",

      time: "-",
    })) || [];

  const students = [...submittedStudents, ...pendingStudents];
  const filteredStudents = students.filter((student) =>
    student.name.toLowerCase().includes(search.toLowerCase()),
  );

  const avgScore = quizResult?.submitted?.length
    ? Math.round(
        quizResult.submitted.reduce((acc, item) => acc + item.score, 0) /
          quizResult.submitted.length,
      )
    : 0;

  const isDeadlineEnded =
    quizResult?.status === "expired" ||
    (quizResult?.deadline && new Date(quizResult.deadline).getTime() < Date.now());
  
 
  if (showHistory) {
    return (
      <AdminQuizHistory
        roomCode={roomCodeNew}
        setShowHistory={setShowHistory}
        resetQuizFlow={resetQuizFlow}
      />
    );
  }

   if (showLeaderboard) {
     return (
       <AdminLeaderboard
         roomCode={roomCodeNew}
         resetQuizFlow={resetQuizFlow}
         setShowHistory={setShowHistory}
       />
     );
   }

  return (
    <>
      {mode === "async" ? (
        <section className="async-page">
          {/* HEADER */}
          <section className="room-header">
            <section className="header-left">
              <button
                type="button"
                className="back-btn"
                onClick={() => navigate(ROUTE_TEST_MANAGEMENT)}
                title="Back to Test Management"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
              </button>
              <section>
                <h3>
                  {quizResult?.chapter || quizResult?.lesson || "Async Quiz Room"}
                </h3>{" "}
                <span className="room-code-text"> Room Code: {roomCodeNew}</span>
                {/* <span> Room Code: {quizResult?.room_code}</span> */}
              </section>
            </section>
            <section className="deadlin-card">
              <section className="deadline-wrapper">
                <img src={assets.ic_deadline} alt="time" />
                <h4 className="dead-line">
                  {" "}
                  Deadline:{" "}
                  {new Date(quizResult?.deadline).toLocaleString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true,
                  })}
                </h4>
              </section>

              <button
                type="button"
                className={`add-student-btn ${isDeadlineEnded ? "disabled" : ""}`}
                disabled={isDeadlineEnded}
                onClick={() => {
                  if (isDeadlineEnded) return;
                  getStudentMailsList(testName, roomCodeNew);
                  setShowAddStudentsModal(true);
                }}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="8.5" cy="7" r="4" />
                  <line x1="20" y1="8" x2="20" y2="14" />
                  <line x1="17" y1="11" x2="23" y2="11" />
                </svg>
                <span>Add Student</span>
              </button>

              <section className="close-room-btn" onClick={closeRoom}>
                <button>{quizResult?.status ==="expired"?"Expired":"Close Room"}</button>
                <img src={assets.ic_cancel} alt="cancel" />
              </section>

              <button
                type="button"
                className="view-360-btn"
                onClick={() =>
                  navigate(ROUTE_CLASSROOM_QUIZ_SUMMARY, {
                    state: {
                      roomCode: roomCodeNew,
                      mode,
                    },
                  })
                }
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                  <path d="M22 12A10 10 0 0 0 12 2v10z" />
                </svg>
                <span>View 360 Analysis</span>
              </button>
            </section>
          </section>

          {/* STATS */}
          <section className="stats">
            <section className="card rating-card">
              <section>
                <p>Joined</p>
                <h2>{quizResult?.total_joined || 0}</h2>
              </section>
              <section className="deadlin-card">
                <img src={assets.ic_joined} alt="joined" />
              </section>
            </section>
            <section className="card rating-card">
              <section>
                <p>Submitted</p>
                <h2>{quizResult?.total_submitted || 0}</h2>
              </section>
              <section className="deadlin-card">
                <img src={assets.ic_submitted} alt="submitted" />
              </section>
            </section>
            <section className="card rating-card">
              <section>
                <p>Avg Score</p>
                <h2>{avgScore} pts</h2>
              </section>

              <section className="deadlin-card">
                <img src={assets.ic_scores} alt="score" />
              </section>
            </section>
          </section>

          {/* TABLE */}
          {quizResult?.total_joined > 0 && (
            <section className="progress-card">
              <section className="table-header">
                <h4>
                  {" "}
                  <span>● </span>Live Progress
                </h4>

                <section className="actions">
                  <section className="quiz-search-bar">
                    <img src={assets.ic_search} alt="search" />
                    <input
                      placeholder="Search students..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </section>
                  <button
                    onClick={() => {
                      setSearch("");
                      getQuizResult();
                    }}
                  >
                    <img src={assets.ic_refresh} />
                    Refresh
                  </button>
                </section>
              </section>

              <section className="table">
                <section className="thead">
                  <span>Student</span>
                  <span>Status</span>
                  <span>Score</span>
                  <span>Attempts</span>
                  <span>Submitted Time</span>
                </section>

                {filteredStudents?.map((s, i) => (
                  <section className="table-row" key={i}>
                    <span className="student">
                      <section className="avatar-pic">{s.name[0]}</section>
                      {s.name}
                    </span>

                    <span
                      className={`status ${s.status.toLowerCase().replace(" ", "-")}`}
                    >
                      {s.status}
                    </span>

                    <span className="score">
                      {s.score} / {s.maxScore || 1000}
                      <section className="bar">
                        <section
                          className="fill"
                          style={{
                            width: `${(s.score / (s.maxScore || 1000)) * 100}%`,
                          }}
                        ></section>
                      </section>
                    </span>

                    <span>{s.attempts}</span>
                    <span>{s.time}</span>
                  </section>
                ))}
              </section>
            </section>
          )}

          {showAddStudentsModal && (
            <AddStudentsModal
              open={showAddStudentsModal}
              onClose={() => setShowAddStudentsModal(false)}
              students={studentMailDetails}
              setSearchQuery={setSearchQuery}
              searchQuery={searchQuery}
              setSelectedStudents={setSelectedStudents}
              selectedStudents={selectedStudents}
              addStudentEmail={addStudentsToRoom}
              isLoading={isLoading}
            />
          )}
        </section>
      ) : (
        <AdminLiveQuizRoom
          roomCode={roomCodeNew}
          setShowLeaderboard={setShowLeaderboard}
        />
      )}
    </>
  );
};
